import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Input } from "@/components/ui/input";
import { MoreVertical, Pencil, Trash2 } from "lucide-react";

const SortableCategoryItem = ({ 
  category,
  editingCategoryId,
  editingCategoryName,
  setEditingCategoryId,
  setEditingCategoryName,
  handleUpdateCategory,
  handleDeleteCategory
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: category.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    backgroundColor: '#F3EEE4',
    border: '1px solid #D6D0C2'
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center justify-between p-3 rounded hover:bg-[#EEE7D8] transition-colors"
    >
      <div className="flex items-center gap-3 flex-1">
        {/* Drag Handle */}
        <div
          {...attributes}
          {...listeners}
          className="cursor-move"
          style={{ color: '#51120A', opacity: 0.5 }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <circle cx="4" cy="4" r="1.5" />
            <circle cx="4" cy="8" r="1.5" />
            <circle cx="4" cy="12" r="1.5" />
            <circle cx="12" cy="4" r="1.5" />
            <circle cx="12" cy="8" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
          </svg>
        </div>

        {/* Category Name */}
        {editingCategoryId === category.id ? (
          <Input
            value={editingCategoryName}
            onChange={(e) => setEditingCategoryName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleUpdateCategory(category.id, editingCategoryName);
              }
            }}
            onBlur={() => handleUpdateCategory(category.id, editingCategoryName)}
            autoFocus
            className="flex-1"
            style={{
              backgroundColor: '#EEE7D8',
              borderColor: '#D6D0C2',
              color: '#51120A',
              fontFamily: "'Bricolage Grotesque', sans-serif"
            }}
          />
        ) : (
          <span style={{ color: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}>
            {category.name}
          </span>
        )}
      </div>

      {/* Actions Dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="p-1 hover:bg-[#D6D0C2] rounded">
            <MoreVertical size={16} style={{ color: '#51120A' }} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" style={{ backgroundColor: '#F3EEE4', border: '1px solid #D6D0C2', boxShadow: 'none' }}>
          <DropdownMenuItem
            onClick={() => {
              setEditingCategoryId(category.id);
              setEditingCategoryName(category.name);
            }}
            className="hover:bg-[#EEE7D8] cursor-pointer"
            style={{ color: '#875C66', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            <Pencil size={14} className="mr-2" />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => handleDeleteCategory(category.id)}
            className="hover:bg-[#EEE7D8] cursor-pointer"
            style={{ color: '#875C66', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            <Trash2 size={14} className="mr-2" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SortableCategoryItem;
